enum TaxaAluguelTipoEnum {
  Fixo = 'Fixo',
  Percentual = 'Percentual',
}

export default TaxaAluguelTipoEnum
